// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./PaymentBody.bs.js";

var paymentExperiencePaymentMethodsV2 = [];

function appendPaymentExperienceV2(paymentBodyArr, paymentMethodType) {
  if (paymentExperiencePaymentMethodsV2.includes(paymentMethodType)) {
    return paymentBodyArr.concat([[
                  "payment_experience",
                  "redirect_to_url"
                ]]);
  } else {
    return paymentBodyArr;
  }
}

function dynamicPaymentBodyV2(paymentMethod, paymentMethodTypeInput, isQrPaymentMethodOpt) {
  var isQrPaymentMethod = isQrPaymentMethodOpt !== undefined ? isQrPaymentMethodOpt : false;
  var resolvedPaymentMethodType = PaymentBody$OrcaPaymentPage.getPaymentMethodType(paymentMethod, paymentMethodTypeInput);
  var paymentMethodExperienceKey = PaymentBody$OrcaPaymentPage.appendPaymentMethodExperience(paymentMethod, resolvedPaymentMethodType, isQrPaymentMethod);
  var paymentMethodBody = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          paymentMethodExperienceKey,
          {}
        ]]);
  var paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          paymentMethod,
          paymentMethodBody
        ]]);
  var baseBody = [
    [
      "payment_method_type",
      paymentMethod
    ],
    [
      "payment_method_subtype",
      resolvedPaymentMethodType
    ],
    [
      "payment_method_data",
      paymentMethodData
    ]
  ];
  return appendPaymentExperienceV2(baseBody, resolvedPaymentMethodType);
}

function epsBody(name, bankName) {
  var billingDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "billing_name",
          name
        ]]);
  var bankDetail = bankName === "" ? "american_express" : bankName;
  var epsDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
        [
          "billing_details",
          billingDetails
        ],
        [
          "bank_name",
          bankDetail
        ]
      ]);
  var bankRedirectBody = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "eps",
          epsDetails
        ]]);
  var paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "bank_redirect",
          bankRedirectBody
        ]]);
  return [
          [
            "payment_method_type",
            "bank_redirect"
          ],
          [
            "payment_method_subtype",
            "eps"
          ],
          [
            "payment_method_data",
            paymentMethodData
          ]
        ];
}

function getPaymentBody(paymentMethod, paymentMethodType, fullName, param, param$1, bank, param$2, $staropt$star, param$3) {
  $staropt$star !== undefined;
  if (paymentMethodType === "eps") {
    return epsBody(fullName, bank);
  } else {
    return dynamicPaymentBodyV2(paymentMethod, paymentMethodType, undefined);
  }
}

function giftCardBody(giftCardType, requiredFieldsBody) {
  return Utils$OrcaPaymentPage.mergeAndFlattenToTuples([
              [
                "payment_method_type",
                "gift_card"
              ],
              [
                "payment_method_subtype",
                giftCardType
              ]
            ], requiredFieldsBody);
}

function splitPaymentBody(appliedGiftCards) {
  var splitPaymentMethodData = appliedGiftCards.map(function (giftCard) {
        return Utils$OrcaPaymentPage.getJsonFromArrayOfJson(giftCardBody(giftCard.giftCardType, giftCard.requiredFieldsBody));
      });
  return [[
            "split_payment_method_data",
            splitPaymentMethodData
          ]];
}

export {
  paymentExperiencePaymentMethodsV2 ,
  appendPaymentExperienceV2 ,
  dynamicPaymentBodyV2 ,
  epsBody ,
  getPaymentBody ,
  giftCardBody ,
  splitPaymentBody ,
}
/* Utils-OrcaPaymentPage Not a pure module */
